import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { provideContextStore } from '@next-qr/lib-ui/store';
import { authModule, initAuthClient, useAuth } from '@next-qr/module-user/web/auth';
import { storeSettingsModule, useStoreSettings } from './storeSettings/store';
import { ApiBaseSection } from './storeSettings/ApiBaseSection';
import { AuthSection } from './storeSettings/AuthSection';
import { getClient } from '../miniApps';

initAuthClient(getClient);

// ─── Page content (rendered inside both store providers) ──────────────────────

function StoreSettingsContent() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const loadInitial = useStoreSettings(s => s.loadInitial);
  const loadUser = useAuth(s => s.loadUser);

  useEffect(() => { loadInitial(); loadUser(); }, []);

  return (
    <div className="mx-auto max-w-xl p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate('/store')}
          className="rounded-lg border border-gray-200 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-50"
        >
          ← {t('common.back')}
        </button>
        <h1 className="text-xl font-bold text-gray-900">{t('storeSettings.title')}</h1>
      </div>

      {/* Card */}
      <div className="rounded-xl bg-white p-5 shadow-sm border border-gray-100 space-y-4">
        <ApiBaseSection />
        <div className="border-t border-gray-100 pt-3">
          <AuthSection />
        </div>
      </div>
    </div>
  );
}

// ─── Public export: mounts both stores, releases on unmount ──────────────────

const WithStoreSettings = provideContextStore(storeSettingsModule, StoreSettingsContent);
export const StoreSettingsPage = provideContextStore(authModule, WithStoreSettings);
